export const GET_TRAINING_CLUBS = "TRAINING_CLUB_GET_CLUBS";
export const GET_TRAINING_CLUB = "TRAINING_CLUB_GET_CLUB";
export const GET_TRAINING_CLUB_MEMBERS = "TRAINING_CLUB_GET_MEMBERS";
export const GET_TRAINING_CLUB_CONTACT = "TRAINING_CLUB_GET_CONTACT";
export const GET_TRAINING_CLUB_ABOUT = "TRAINING_CLUB_GET_ABOUT";
export const GET_TRAINING_CLUB_EVENTS = "TRAINING_CLUB_GET_EVENTS";
export const GET_TRAINING_CLUB_PREVIEW = "TRAINING_CLUB_GET_PREVIEW";
export const RESET_PREVIEW = "TRAINING_CLUB_RESET_PREVIEW";
export const RESET_CLUB_STATE = "TRAINING_CLUB_RESET_CLUB_STATE";
